import type z from "zod";

import { zSchema } from "../../../../entity";

const zOut = zSchema.omit({
  password: true,
});
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
